<template>

    <div v-if="show" class="terms__container">

        <markdown
            :text="text"
            class="text-baseRegular mr__16"
            :blank="true"
            @clickLink="close"></markdown>

        <img @click="close" src="/img/icons/close-white.svg" class="img__20">

    </div>

</template>

<script>
import Vuex from 'vuex'

import Agreements from '../modules/agreements'
import Firebase from '../modules/firebase'

import Markdown from '../components/Markdown'

export default {

    name: 'agreements-update',

    components: {Markdown},

    computed: {
        ...Vuex.mapGetters([
            'isConnected',
            'isNewPrivacy'
        ])
    },

    watch: {
        isConnected: function (isConnected) {
            if (isConnected && this.isNewPrivacy) {
                this.checkAgreements()
            }
        }
    },

    data() {
        return {
            show: false,
            text: '',
            privacyTarget: 'privacy',
            termsTarget: 'terms',
            needReadTerms: false,
            needReadPrivacy: false
        }
    },

    mounted() {
        this.show = false
        this.text = ''
    },

    methods: {

        checkAgreements() {
            this.needReadTerms = false
            this.needReadPrivacy = false

            Firebase.getValue('last_terms_update')
                .then(lastTermsUpdate => {

                    Firebase.getValue('last_privacy_update')
                        // eslint-disable-next-line complexity
                        .then(async lastPrivacyUpdate => {

                            const agreements = await Agreements.get()

                            if (agreements) {

                                this.needReadTerms = !(lastTermsUpdate && agreements.terms && new Date(agreements.terms).getTime() > new Date(lastTermsUpdate).getTime())
                                this.needReadPrivacy = !(lastPrivacyUpdate && agreements.privacy && new Date(agreements.privacy).getTime() > new Date(lastPrivacyUpdate).getTime())

                                if (this.needReadTerms || this.needReadPrivacy) {
                                    if (this.needReadTerms && this.needReadPrivacy) {
                                        // like banner_cookies_description , privacy_and_cgu_update LK is not correct
                                        // for the moment and can't be updated in Lokalise?
                                        // (privacy_policy) should be (privacy)
                                        this.text = this.clearStaticLinksRedirection(this.$t('privacy_and_cgu_update'))

                                    } else if (this.needReadTerms) {
                                        this.text = this.clearStaticLinksRedirection(this.$t('cgu_update'))
                                    } else {
                                        this.text = this.clearStaticLinksRedirection(this.$t('privacy_policy_update'))
                                    }
                                    this.show = true
                                }
                            }
                        })
                        .catch(() => {
                        })
                })
                .catch(() => {
                })
        },

        close() {
            if (this.needReadPrivacy) {
                Agreements.set.privacy()
            }
            if (this.needReadTerms) {
                Agreements.set.terms()
            }
            this.show = false
        }
    }

}
</script>

<style lang="scss" scoped>

.terms {

    &__container {

        position: fixed;
        bottom: 80px;
        left: 16px;
        right: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.10), 0px 4px 6px 0px rgba(0, 0, 0, 0.05);
        background-color: $midnight;
        color: $white;
        border-radius: 12px;
        @media screen and (min-width: $above-tablet-length) {
            position: absolute;
            height: fit-content;
            top: 89px;
            right: 24px;
            left: 345px;
        }
    }
}


</style>
